module.exports = __webpack_public_path__ + "img/02q_marketing.5858ce9d.jpg";